import { createAction } from 'redux-actions';
import * as types from './task-list-constants';

export const getTaskListRequest = createAction(types.GET_TASKLIST_REQUEST);
export const getTaskListSuccess = createAction(types.GET_TASKLIST_SUCCESS);
export const getTaskListFailure = createAction(types.GET_TASKLIST_FAILURE);
